import React from 'react';
import RequestSuccessDF from '../components/SimulatorsComponents/DefualtSimulators/RequestSuccessDF';
import { payment_request_sent } from '../utils/DictionaryManagementUtils';
//= ========================================================================
const Sim_F12_RequestPaymentSuccess = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <RequestSuccessDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    largeText={payment_request_sent}
  />
);

export default Sim_F12_RequestPaymentSuccess;
